import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import ProgressBar from "./trainingSummary/progressBar";
import ProfileImg from "@icarius-common/profileImg";
import { Alert } from "@material-ui/lab";

const ParticipantsDialog = (props) => {

  const {
    open,
    data,
    handleClose,
  } = props;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("participants")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            {
              !data?.length &&
              <Alert variant="filled" severity="info">
                {getLocalizedString("noParticipantsFound")}
              </Alert>
            }
            {
              data.map((participant, participantIndex) => {
                return (
                  <div
                    key={participantIndex}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 15,
                    }}
                  >
                    <ProfileImg
                      size={35}
                      image={participant.img}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 5,
                      }}
                    >
                      <Typography className="whiteText" style={{ paddingLeft: 5 }}>
                        {participant.name}
                      </Typography>
                      <ProgressBar
                        small
                        value={participant.progress}
                      />
                    </div>
                  </div>
                )
              })
            }
          </div>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction isAccept onClick={handleClose} text={getLocalizedString("close")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ParticipantsDialog;